<template>
  <div id="header" class="h-16 flex justify-between items-center">
    <div>
      <span class="text-xl font-bold text-blue-600 mr-2">
        {{
          $route.query.labelheader
            ? $route.query.labelheader
            : 'PRPC DATA CENTRE MONITORING'
        }}
      </span>
    </div>

    <!-- Alarm Dialog -->
      <AlarmTable
      :visible="alarmTableDialogVisible"
      :notifications="notifications"
      :doesSoundPlay="doesAlarmSoundPlay" />
    
    <div class="flex items-center">
      <span
        class="el-dropdown-link text-lg font-bold text-gray-500 m-8 cursor-pointer"
        @click="$router.push('/')"
      >
        HOME
      </span>
      <!-- Dashboard Dropdown -->
      <el-dropdown @command="handleMenuCommand">
        <span class="el-dropdown-link text-lg font-bold text-gray-500">
          DASHBOARD
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            command="/portal?labelheader=PENGERANG DATA CENTRE&location=PDC"
            >PENGERANG DATA CENTRE</el-dropdown-item
          >
          <el-dropdown-item
            command="/portal?labelheader=THMO SERVER ROOM&location=THMO"
            >THMO SERVER ROOM</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <!-- Report Dropdown -->
      <el-dropdown @command="handleMenuCommand" class="m-8">
        <span class="el-dropdown-link text-lg font-bold text-gray-500">
          REPORT
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="/report/alarm?labelheader=Alarm Report"
            >ALARM</el-dropdown-item
          >
          <el-dropdown-item
            command="/report/temperature?labelheader=Temperature Report"
            >TEMPERATURE</el-dropdown-item
          >
          <el-dropdown-item
            command="/report/humidity?labelheader=Humidity Report"
            >HUMIDITY</el-dropdown-item
          >
          <el-dropdown-item command="/report/ups?labelheader=UPS Report"
            >UPS</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <!-- Administartor dropdown -->
      <span
        v-if="isAdmin"
        class="el-dropdown-link text-lg font-bold text-gray-500 mr-4 cursor-pointer"
        @click="$router.push('/administrator')"
      >
        ADMINISTRATOR
      </span>
      <!-- DCE -->
      <el-tooltip
        v-if="isAdmin"
        class="item"
        effect="dark"
        content="DCE – Data Center Expert"
        placement="top-start">
        <div
          class="bg-red-600 rounded-full h-10 w-10 border flex justify-center items-center mr-5 hover:bg-red-700 cursor-pointer"
          @click="goTo({ path: DCEUrl, newTab: true })">
          <img src="@/assets/images/icon-eye.png" class="h-6">
        </div>
      </el-tooltip>
      <!-- DCO -->
      <el-tooltip
        v-if="isAdmin"
        class="item"
        effect="dark"
        content="DCO – Data Center Operation"
        placement="top-start">
        <div
          class="bg-blue-600 rounded-full h-10 w-10 border flex justify-center items-center hover:bg-blue-700 cursor-pointer"
          @click="goTo({ path: DCOUrl, newTab: true })">
          <img src="@/assets/images/icon-puzzle.png" class="h-6">
        </div>
      </el-tooltip>
      <!-- MENU Notification dropdown -->
      <div class="ml-4 relative">
        <div
          class="w-10 h-10 border rounded-full hover:bg-gray-600 flex justify-center items-center hover:text-white cursor-pointer"
          @click="visibleAlarmDialog()">
          <i class="el-icon-bell text-xl"></i>
        </div>
        <!-- notification ping -->
        <div
          v-if="notifications.length > 0"
          class="flex absolute h-3 w-3 top-0 right-0 -mt-0 -mr-2"
        >
          <div
            class="animate-ping absolute inline-flex h-full w-full rounded-full bg-pink-400 opacity-75"
          />
          <div
            class="relative flex justify-center items-center rounded-full h-3 w-3 bg-pink-500 text-xs text-white"
          >
            <!-- {{ notifications.length }} -->
          </div>
        </div>
      </div>
      <!-- End of MENU notification dropdown -->
      <el-tooltip
        class="item"
        effect="dark"
        content="Logout"
        placement="top-start"
      >
        <div
          class="flex justify-center items-center ml-4 border p-2 rounded-full w-10 h-10 hover:bg-red-500 hover:text-white cursor-pointer"
          @click="logout()">
          <i class="el-icon-switch-button text-xl"></i>
        </div>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import AlarmTable from '@/components/Portal/AlarmTable.vue'
import moment from 'moment'

export default {
  components: {
    AlarmTable
  },
  data() {
    return {
      DCEUrl: '',
      DCOUrl: '',
      notifications: [],
      alarmTableDialogVisible: false,
      doesAlarmSoundPlay: true,
      interval: undefined
    }
  },
  computed: {
    isAdmin() {
      return this.$store.state.auth.isAdmin
    },
  },
  mounted() {
    this.fetchMasterConfig();
    this.fetchAlarmNotification()

    this.interval = setInterval(() => {
      this.fetchAlarmNotification()
    }, 60000)
  },
  methods: {
    handleMenuCommand(command) {
      this.$router.push(command)
    },
    goTo({ path = '', newTab = false }) {
      window.open(path, newTab ? '_blank' : '')
    },
    async fetchMasterConfig() {
      const res = await this.$axios.get('MasterConfigDCE/GetAll')
      this.DCEUrl = res.data.find((x) =>
        x.Server_name.includes('DCE')
      )?.Base_Url
      this.DCOUrl = res.data.find((x) =>
        x.Server_name.includes('DCO')
      )?.Base_Url
    },
    visibleAlarmDialog() {
      this.alarmTableDialogVisible = false
      // localStorage.setItem("doesAlarmSoundPlay", this.alarmTableDialogVisible)
      // this.doesAlarmSoundPlay = true
      setTimeout(() => {
        this.alarmTableDialogVisible = true
        // localStorage.setItem("doesAlarmSoundPlay", this.alarmTableDialogVisible)
        // localStorage.setItem("doesAlarmSoundPlay", false)
        // this.doesAlarmSoundPlay = false
      }, 500);
    },
    async fetchAlarmNotification() {
      const fetchCritical = this.$axios.get(
        'Alarms/GetALLActiveAlarmWithSeverity?severity=CRITICAL'
      )
      // const fetchWarning = this.$axios.get('Alarms/GetALLActiveAlarmWithSeverity?severity=WARNING')
      // const fetchInformational = this.$axios.get('Alarms/GetALLActiveAlarmWithSeverity?severity=INFORMATIONAL')

      const results = await Promise.allSettled([fetchCritical])

      this.notifications = []
      
      // Assigning data of each result no this.notifications
      results.forEach((item) => {
        if (item.status === 'fulfilled')
          this.notifications = this.notifications.concat(item.value.data)
      })

      this.notifications = this.notifications.map((x) => {
        x.ActiveTime = moment(x.ActiveTime).format('YYYY-MM-DD hh:mm:ss')
        return x
      })
    },
    logout() {
        window.location.href = '/logout'
    }
  }
}
</script>

<style scoped>
.router-link-active {
  @apply text-blue-600;
}
</style>
